const red = "#D7153A";
const dotColor = "#008B8B";
const darkBackgroundGrey = "#E4E4E6";
const backgroundGrey = "#F4F4F7";
const linkGreen = "#008535";
const darkTeal = "#008B8B";
const sectionHeader = "#A0A5AE";
const dpieBlack = "#333333";
const selectionRed = "#D7153A";
const darkGreen = "#013300";

export const colors = {
  red,
  backgroundGrey,
  linkGreen,
  dotColor,
  darkTeal,
  sectionHeader,
  dpieBlack,
  darkBackgroundGrey,
  selectionRed,
  darkGreen,
};

export const iconColors = {
  "animal-gifts": "#5399CF",
  "art-design": "#C094C4",
  experiences: "#D05199",
  fashion: "#DF90B0",
  food: "#7B80C6",
  "for-kids": "#E76A61",
  hampers: "#DF98CF",
  wellbeing: "#37B0CE",
  "wine-beer": "#64C0B6",
};

export const ICON_HEIGHT = 24;
export const ICON_WIDTH = 24;
export const CIRCLE_RADIUS = 6;
export const STROKE_WIDTH = 2;
export const SIDEBAR_WIDTH = 360;
export const SIDEBAR_HANDLE_WIDTH = 24;

export const fontWeights = {
  bold: "600",
};

export const fontSizes = {
  small: "0.9em",
  extraSmall: "0.8em",
  h2: "1.5em",
};

export const mobileBreakpoint = 500;



// WEBPACK FOOTER //
// ./src/modules/theme.js